const obs = new IntersectionObserver(
    (entries) => {
        entries.forEach((e) => {
            if (e.isIntersecting) {
                e.target.classList.add("visible");
                obs.unobserve(e.target);
            }
        });
    },
    { threshold: 0.12 },
);
document.querySelectorAll(".reveal").forEach((el) => obs.observe(el));

document
    .querySelectorAll(".tp-slider-thumb-3[data-background]")
    .forEach((slide) => {
        const viewportWidth = window.innerWidth;
        const background =
            viewportWidth <= 767
                ? slide.dataset.mobileBackground
                : viewportWidth < 1200
                  ? slide.dataset.tabletBackground
                  : slide.dataset.background;
        if (background)
            slide.style.backgroundImage = `url("${encodeURI(background)}")`;
    });

if (window.jQuery?.fn?.owlCarousel) {
    window.jQuery(".tp-slider-active-3:not(.owl-loaded)").each(function () {
        const slider = window.jQuery(this);
        slider.owlCarousel({
            items: 1,
            loop:
                slider.data("owl-loop") === true ||
                slider.data("owl-loop") === "true",
            autoplay:
                slider.data("owl-auto") === true ||
                slider.data("owl-auto") === "true",
            autoplayTimeout: Number(slider.data("owl-speed")) || 5000,
            autoplayHoverPause: true,
            nav: true,
            dots: true,
            mouseDrag: true,
            touchDrag: true,
            smartSpeed: Number(slider.data("owl-duration")) || 1000,
            navText: [
                '<span aria-hidden="true">‹</span>',
                '<span aria-hidden="true">›</span>',
            ],
        });
    });
}

const interestSelect = document.getElementById("interestSelect");
document.querySelectorAll(".product-cta[data-interest]").forEach((link) => {
    link.addEventListener("click", () => {
        const interest = link.dataset.interest;
        if (
            interestSelect &&
            [...interestSelect.options].some(
                (o) => o.value === interest || o.text === interest,
            )
        ) {
            interestSelect.value = interest;
        }
    });
});

const categoryLabels = Object.fromEntries(
    [...document.querySelectorAll("[data-category-trigger]")].map((el) => [
        el.dataset.categoryTrigger,
        el.dataset.categoryLabel || el.textContent.trim(),
    ]),
);
const categoryUrls = Object.fromEntries(
    [...document.querySelectorAll("[data-category-trigger]")].map((el) => [
        el.dataset.categoryTrigger,
        el.dataset.categoryUrl,
    ]),
);
const productSection = document.querySelector(".products");
const productLimit = Number(productSection?.dataset.productLimit || 0);
const productCards = [
    ...document.querySelectorAll(".product-card[data-categories]"),
];
const categoryTriggers = [
    ...document.querySelectorAll("[data-category-trigger]"),
];
const categoryTitle = document.getElementById("productCategoryTitle");
const productCount = document.getElementById("productCount");
const productMoreBtn = document.getElementById("productMoreBtn");

function getCategoryUrl(category = "all") {
    return (
        categoryUrls[category] ||
        categoryUrls.all ||
        document.querySelector(".products")?.dataset.catalogUrl ||
        "#products"
    );
}
function setActiveCategory(category = "all") {
    if (!categoryLabels[category]) category = "all";
    const currentLabel = categoryLabels[category];
    const matchesCategory = (card) =>
        category === "all" ||
        card.dataset.categories?.split(",").includes(category);
    const matchedCards = productCards.filter(matchesCategory);
    let visibleCount = 0;
    productCards.forEach((card) => {
        const isMatch = matchesCategory(card);
        const show = isMatch && (!productLimit || visibleCount < productLimit);
        if (show) visibleCount++;
        card.classList.toggle("filtered-out", !show);
        card.classList.toggle("is-visible", show);
    });
    categoryTriggers.forEach((link) =>
        link.classList.toggle(
            "active",
            link.dataset.categoryTrigger === category,
        ),
    );
    if (categoryTitle) categoryTitle.textContent = currentLabel;
    if (productCount) {
        productCount.textContent =
            productLimit && matchedCards.length > visibleCount
                ? `${visibleCount}/${matchedCards.length} sản phẩm`
                : `${matchedCards.length} sản phẩm`;
    }
    if (productMoreBtn) {
        productMoreBtn.href = getCategoryUrl(category);
        productMoreBtn.textContent =
            category === "all"
                ? "Xem tất cả sản phẩm →"
                : `Xem thêm ${currentLabel.toLowerCase()} →`;
    }
}

categoryTriggers.forEach((link) => {
    link.addEventListener("click", (e) => {
        const category = link.dataset.categoryTrigger || "all";
        e.preventDefault();
        setActiveCategory(category);
        document
            .getElementById("products")
            ?.scrollIntoView({ behavior: "smooth", block: "start" });
        window.thuanthienHeader?.close();
    });
});
const initialParams = new URLSearchParams(location.search);
setActiveCategory(initialParams.get("category") || "all");

const partnerTrack = document.getElementById("partnerTrack");
document
    .querySelector(".partner-arrow.prev")
    ?.addEventListener("click", () =>
        partnerTrack?.scrollBy({ left: -400, behavior: "smooth" }),
    );
document
    .querySelector(".partner-arrow.next")
    ?.addEventListener("click", () =>
        partnerTrack?.scrollBy({ left: 400, behavior: "smooth" }),
    );

const coreValuesSection = document.getElementById("core-values");
const motionToggle = document.querySelector(".cv-motion-toggle");
motionToggle?.addEventListener("click", () => {
    const paused = coreValuesSection.classList.toggle("is-paused");
    motionToggle.setAttribute("aria-pressed", String(paused));
    motionToggle.textContent = paused
        ? "Tiếp tục chuyển động"
        : "Tạm dừng chuyển động";
});

const interestLabels = {
    "quat-cong-nghiep": "QUẠT CÔNG NGHIỆP HƯỚNG TRỤC",
    "thong-gio": "Thi công hệ thống thông gió",
    "hut-khoi": "Hệ thống hút khói",
    "lam-mat": "MÁY LÀM MÁT CÔNG NGHIỆP",
    "ong-gio": "ỐNG GIÓ VÀ PHỤ KIỆN",
    "bao-tri": "Bảo trì hệ thống",
};
const requestedInterest =
    interestLabels[new URLSearchParams(location.search).get("interest")];
if (interestSelect && requestedInterest)
    interestSelect.value = requestedInterest;

const requestedProduct = new URLSearchParams(location.search).get("product");
if (requestedProduct && interestSelect) {
    const option = document.createElement("option");
    option.value = requestedProduct;
    option.textContent = requestedProduct;
    interestSelect.appendChild(option);
    interestSelect.value = requestedProduct;
}
